export class LatestQuestionBankViewReq {
    classId: string;
    subject: string;
    chapter: string;
    marks: string;
    language: string;
    activeOnly?: boolean;
    constructor(classId: string, subject: string, chapter: string, marks: string, language: string,activeOnly?: boolean) {
        this.classId = classId;
        this.subject = subject;
        this.chapter = chapter;
        this.language = language;
        this.marks = marks;
        this.activeOnly = activeOnly;
    }
}